<template>
    <nav class="navbar navbar-default navbar-fixed-top" @click="gotoErr">
        <div>
            <div class="navbar-header logo">
                <router-link v-show='can("god4all.admin.user.client.client-admin.any")' to="/" class="navbar-brand" >
                    <!-- server path to logo -->
                    <!--<img src="/logo/AlarmBot_Logo-outline.svg" @click="closeAlertWarning()" :title="getTranslation('app_title')">-->
                    <img src="/static/logo/AlarmBot_Logo-outline.svg" @click="closeAlertWarning()"
                         :title="getTranslation('app_title')">
                    <!--<span class="fa fa-bell-o" aria-hidden="true" style="font-size: 16px;"></span>-->
                    <!--<span-->
                        <!--@click="closeAlertWarning()">{{ getTranslation('app_title') }}-->
                    <!--</span>-->
                </router-link>
            </div>
            <div class="pull-right">
                <banet-clock class="headerClock"></banet-clock>
                <div class="collapse navbar-collapse pull-right">
                    <ul class="nav navbar-nav navbar-right">
                        <li v-on-clickaway="dropClose" class="dropdown" :class="{ open: isOpened }">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button"
                               aria-haspopup="true" aria-expanded="false" @click.prevent="dropToggle">
                                <!--<span class="glyphicon glyphicon-cog" aria-hidden="true"></span>-->
                                <!--{{ loggedUser.firstName }} {{ loggedUser.lastName }}-->
                                <span class="fa fa-user-circle-o"></span> &nbsp;
                                {{ loggedUser.firstName }} {{ loggedUser.lastName }}
                                <span class="glyphicon glyphicon-menu-hamburger" aria-hidden="true"></span>
                            </a>
                            <ul class="dropdown-menu" @click="dropToggle">
                                <router-link v-show='can("god4all.admin")' to="/clients" activeClass="active" tag="li">
                                    <a>
                                        <span class="fa fa-address-book-o" aria-hidden="true"></span>
                                        <span>{{ getTranslation('menu_main_client_list') }}</span>
                                    </a>
                                </router-link>
                                <router-link v-show='can("god4all.admin")' to="/users" activeClass="active"
                                             tag="li">
                                    <a>
                                        <span class="fa fa-users" aria-hidden="true"></span>
                                        <span @click="closeAlertWarning()">{{ getTranslation('menu_main_user_list')
                            }}</span></a></router-link>
                                <router-link  v-show='can("god4all.admin")'to="/translations" activeClass="active"
                                              tag="li"><a>
                                    <span class="glyphicon glyphicon-text-size" aria-hidden="true"></span>
                                    <span @click="closeAlertWarning()">{{
                            getTranslation('menu_main_translation_list')
                            }}</span></a></router-link>

                                <router-link  v-show='can("god4all.admin")'to="/history" activeClass="active"
                                              tag="li"><a>
                                    <span class="glyphicon glyphicon-time" aria-hidden="true"></span>
                                    <span @click="closeAlertWarning()">{{
                            getTranslation('menu_main_history')
                            }}</span></a></router-link>

                                <li  v-show='can("god4all.admin")' role="separator" class="divider"></li>

                                <router-link v-show='can("god4all.admin.user.client.client-admin")'  v-if="isLogged" to="/myprofile"
                                             activeClass="active"
                                             tag="li">
                                    <a>
                                        <span class="glyphicon glyphicon-user" aria-hidden="true"></span>
                                        <span @click="closeAlertWarning()">
                                        {{ getTranslation('menu_main_my_profile') }} </span>
                                    </a>
                                </router-link>

                                <!--<li role="separator" class="divider"></li>-->
                                <li @click.prevent="logout" style="cursor:pointer">
                                    <a @click="closeAlertWarning()">
                                        <span class="glyphicon glyphicon-log-out" aria-hidden="true"></span> {{
                                        getTranslation('app_lbl_action_logout') }} </a>
                                </li>

                            </ul>
                        </li>
                    </ul>
                </div><!-- /.navbar-collapse -->
            </div>
        </div><!-- /.container-fluid -->
    </nav>
</template>

<script type="text/babel">

    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import { userMixin } from '../../../../Banet/mixins/userMixin.js';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';
    import Clock from '../clock.vue';

    export default {
       components: {
          banetClock: Clock
       },
        created: function(){

        },
        mixins: [translationMixin, dropdownMixin, userMixin, clickaway],
        data: function(){
            return {
                errCounter: 0
            }
        },
        computed: {

        },
        methods: {
            logout: function(){
                this.$store.dispatch('logOut');
            },
            gotoErr: function(){
                if(this.errCounter == 0){
                    this.resetTimeout();
                }
                this.errCounter ++;
                if(this.errCounter >= 10){
                    alert('Smile :)');
                }
            },
            resetTimeout: function(){
                let that = this;
                setTimeout(function(){
                    that.errCounter = 0;
                }, 1600)
            },
            closeAlertWarning: function(){
                this.$store.dispatch('unsetErrors');
            }
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// Header.vue?250b6155